<template>
  <div class="input">
    <input
      :type="typeInput"
      v-model="model"
      :class="{error: data.error, complete: data.error === '', notnull: model && (model.length > 0), padding: data.type === 'password' || false}"
      :maxlength="data.max && data.type === 'text' ? data.max || 30 : null"
      />
    <div class="title">
      {{ data.label || '' }}
    </div>
    <div class="errorIcon animate__animated animate__bounceIn" v-if="data.error || data.error === ''" :title="data.error" :class="{complete: data.error === ''}">
      {{ data.error === '' ? '&#10004;' : '!' }}
    </div>
    <EyeIcon class="icon" v-if="data.type === 'password' && typeInput === 'password'" @click="typeInput = 'text'" />
    <EyeNotIcon class="icon" v-if="data.type === 'password' && typeInput === 'text'" @click="typeInput = 'password'" />
  </div>
</template>

<script>
import EyeIcon from '@/assets/svg/eye-icon.svg?inline'
import EyeNotIcon from '@/assets/svg/eye-not-icon.svg?inline'

export default {
  components: {
    EyeIcon,
    EyeNotIcon
  },
  props: {
    data: Object
  },
  data () {
    return {
      model: null,
      typeInput: 'text',
      error: null,
      complete: false,
      viewPassword: false
    }
  },
  watch: {
    model (val) {
      if (this.data.type === 'number') {
        val = val.toString().replace(this.data.req, '')
        if (Number(val) > this.data.max) {
          val = this.data.max
        }
        this.model = val
      }
      this.$emit('set', val)
    }
  },
  mounted () {
    this.typeInput = this.data.type === 'number' ? 'text' : this.data.type
    this.error = this.data.error || ''
    this.model = this.data.value || ''
  },
  updated () {
    this.model = this.data.value || ''
  }
}
</script>

<style lang="scss" scoped>
.input{
  @include box(100%, 3.5vw, relative, 0, 0, null, null, 0, null);
  @include flex(center, center, column);
  @include padding(0, 1vw, 0, 0);
  .title{
    @include box(100%, 2.5vw, absolute, 0, 1vw, null, null, 0, null);
    @include text(0.85vw, 400, null, null, left, $inputLabel);
    @include flex(left, center, row);
  }
  input{
    @include box(100%, 2.5vw, relative, 0, 0, null, null, 0, $input);
    @include border(null, solid, $inputBorder, null, null, null, 0.06vw);
    @include text(0.8vw, 400, null, null, left, $inputColor);
    padding: 0;
    z-index: 2;
    padding-right: 2vw;
    &.padding{
      padding-right: 4vw;
    }
    &:focus + .title{
      @include box(null, null, absolute, 0, -0.5vw, null, null, null, null);
      @include text(0.7vw, null, null, null, null, $inputColorActive);
    }
    &.notnull + .title{
      @include box(null, null, absolute, 0, -0.5vw, null, null, null, null);
      @include text(0.7vw, null, null, null, null, $inputColorActive);
    }
    &.error{
      @include border(null, solid, $inputBorderError, null, null, null, 0.06vw);
    }
    &.complete{
      @include border(null, solid, $inputBorderComplete, null, null, null, 0.06vw);
    }
  }
  .errorIcon{
    @include box(0.8vw, 0.8vw, absolute, null, null, 0, null, 50%, $inputErrorIcon);
    @include flex(center, center, row);
    @include text(0.4vw, 800, null, null, null, $inputErrorIconColor);
    z-index: 2;
    &.error{
      cursor: help;
      @include box(null, null, null, null, null, null, null, null, $inputErrorIcon);
    }
    &.complete{
      cursor: default;
      @include box(null, null, null, null, null, null, null, null, $inputCompleteIcon);
    }
  }
  .icon{
    @include box(0.8vw, 0.8vw, absolute, null, null, 2vw, null, null, null);
    cursor: pointer;
    z-index: 2;
    transition: 0.3s;
    fill: $inputPasswordIcon;
    &:hover{
      transform: scale(1.1);
      fill: $inputPasswordIconHover;
    }
  }
}
</style>
